import { React, useState, useContext } from "react";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "../../api/axios";
import { useLogin } from "../../api/mutations";
import AuthContext from "../../context/AuthContext";
import Navauth from "../partials/navauth";
import { NavLink, useNavigate } from "react-router-dom";
import { formatAPIErrorMessages, saveToken } from "../../lib/utils";
import { LoginSchema } from "../../validation/schema";
import { Button, useToast } from "../../lib";
import { useGetCurrentUser } from "../../api/queries";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";
import logo from "../../images/logo.png";

const Login = () => {
  const { setAuth } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const { mutateAsync, isPending } = useLogin();
  const toast = useToast();
  const navigate = useNavigate();
  const [, setAuthUser] = useRecoilState(auth_user);
  const { refetch, isLoading } = useGetCurrentUser();

  const handleSubmit = async (values) => {
    try {
      // setError("");

      const response = await mutateAsync(values);
      const accessToken = response?.accessToken;
      const refreshToken = response?.refreshToken;
      saveToken("accessToken", accessToken);
      saveToken("refreshToken", refreshToken);

      const { data } = await refetch();
      setAuthUser(data);
      setAuth({ accessToken, refreshToken });
      toast({
        type: "success",
        message: "Authenticated",
      });
      navigate("/");
      setSuccess(true);
    } catch (error) {
      console.log(error, "error");
      if (!error?.response) {
        setError(
          <div
            style={{
              color: "black",
              textAlign: "center",
              marginTop: 15,
              backgroundColor: "#80ffb3",
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 10,
              paddingBottom: 10,
              width: "fit-content",
              borderRadius: 38,
              fontFamily: "Outfit,sans-serif",
              display: "block",
              marginLeft: "auto",
              marginRight: "right",
            }}
          >
            No Server response found{" "}
          </div>
        );
      } else {
        // setError(formatAPIErrorMessages(error?.response?.data?.message));
        toast({
          type: "error",
          message: error?.response?.data?.message ?? "An Error occured",
        });
      }
    }
  };

  return (
    <div>
      {/* TODO: This success variable allows you to transition when you get your tokens */}
      {success ? <Navauth /> : <></>}
      <div className="container w-full min-h-screen flex justify-center items-center relative ">
        <div className="absolute top-0 left-0 mt-6">
          <NavLink to="/">
            <img
              src={logo}
              className="img-fluid ml-6 lg:scale-125 logo "
              alt="logo"
            />
          </NavLink>
        </div>
        <div className="row lg:px-[160px] lg:my-[170px] py-20">
          <div className="col-lg-12">
            <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center">
              <h3 className="header-signup lg:text-[30px] text-[25px] md:text-[40px]">
                Login to your account
              </h3>
              <span className="flex gap-2  mt-2 lg:mt-0">
                <p className="forgot"> Forgot Password?</p>
                <span className="underline">
                  {" "}
                  <NavLink to="/password" className="terms text-[#7435F5]">
                    {" "}
                    Reset here
                  </NavLink>{" "}
                </span>
              </span>
            </div>
            <Formik
              initialValues={{ username: "", password: "" }}
              onSubmit={handleSubmit}
              validationSchema={LoginSchema}
            >
              {({ isSubmitting }) => (
                <Form className="row padding-form ">
                  {error ? <p className="form-error">{error}</p> : <></>}
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="text"
                      name="username"
                      placeholder="Enter Username e.g Swiftkid"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="username"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="password"
                      name="password"
                      placeholder="Enter Password"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="password"
                      component="div"
                    />
                  </div>
                  <div className="flex lg:flex-row flex-col lg:justify-between lg:items-center mt-10">
                    <p className="forgot">
                      Don't have an account?{" "}
                      <span className="terms">
                        {" "}
                        <NavLink to="/signup" className="login">
                          {" "}
                          Register{" "}
                        </NavLink>
                      </span>
                    </p>

                    <div className="flex justify-center lg:justify-end">
                      <Button
                        // onClick={handleSubmit}
                        loading={isPending || isLoading}
                      >
                        Login
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
